import digitalData from 'digital-data';
import { MERCHANDISE } from '../constants';

function isPackage(path) {
  return path.some((name) => name.indexOf('Package') > -1);
}

export const quickView = () => {
  window.LIFE_CYCLE_EVENT_BUS.on('quick-view.click-section', ({ output }) => {
    const { title, productType, path } = output;
    if (productType === MERCHANDISE && isPackage(path)) {
      digitalData.event = digitalData.event || [];
      digitalData.event.push({
        category: {
          primaryCategory: 'interaction'
        },
        eventInfo: {
          eventName: 'pip sub-content'
        },
        subContent: {
          component: 'product-details',
          section: 'gen-merch-package',
          target: title
        }
      });
    }

  });
};